import { getLanguage } from "@Views/utils/StringUtils";
import { useEffect, useImperativeHandle, useRef } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import GuideLineForUsePopup from "./comp/GuideLineForUsePopupRef";
import RejectionEmailCollectionPopup from "./comp/RejectionEmailCollectionPopupRef";

const Footer = ({ getMsg }: any) => {
  const msg = getMsg();
  const history = useHistory();
  const footerRef: any = useRef();

  const guideLineForUsePopupRef: any = useRef();
  const rejectionEmailCollectionPopupRef: any = useRef();

  useEffect(() => {

  }, [])

  return (
    <>
      <GuideLineForUsePopup ref={guideLineForUsePopupRef} />
      <RejectionEmailCollectionPopup ref={rejectionEmailCollectionPopupRef} />
      <div className='wrap-foot mtn' ref={footerRef}>
        <footer className="footer footer-hj header_employment-footer">
          <div className="footer-inner clearfix">
            <div className="footer-logo">
              <h1 className="logo">
                <a className="logo-link">
                  <span className="logo-pic"></span>
                </a>
              </h1>

            </div>
            <div className="site-info">
              <div className="site-detail clearfix">
                <ul className="site-info-list clearfix">
                  <li className="site-info-list-item">
                    <a style={{ color: "#ff6767", fontSize: "15px", fontWeight: "bold" }} tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { window.open(msg['privacyGuideLineUrl']) } }} onClick={() => window.open(msg['privacyGuideLineUrl'])}>{msg['footer']['privacyGuidelines']}</a>
                  </li>
                  {
                    getLanguage() === 'ko' &&
                    <li className="site-info-list-item">
                      <a tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { rejectionEmailCollectionPopupRef['current'].isOpen(true) } }} onClick={() => rejectionEmailCollectionPopupRef['current'].isOpen(true)}>{msg['footer']['rejectionEmailCollection']}</a>
                    </li>
                  }
                </ul>
                <div className="site-link">
                  <div className="btn-group">
                    <a className="btn btn-gray-outline btn-sm" tabIndex={0} onKeyUp={(e) => { if ((e['code'] === 'Space' || e['code'] === 'Enter')) { window.open('https://ecos.bok.or.kr') } }} onClick={() => window.open('https://ecos.bok.or.kr')}>{msg['footer']['shortcuts']}</a>
                  </div>
                </div>
              </div>
              <div className="address-set">
                <address className="address-detail">
                  <span>{msg['footer']['address']}</span>
                  <span>{msg['footer']['tel']}</span>
                </address>
                <p className="copy">{msg['copyright']}</p>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default Footer;